import axios from 'axios';

// Use current origin for API calls — Kubernetes ingress routes /api/* to backend
// regardless of whether we're on yublink.com or the preview URL
const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Attach token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('yublink_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
export { API, BACKEND_URL };
